import React from 'react';
import './st_grid_active_slot_style.scss';

class SpaceTagGridActiveSlot extends React.Component {

  callEmployee = () => {
    this.props.call();
  };

  render() {
    let value = this.props.value;
    return(
      <div className={'st_grid_active'}
        onClick={this.callEmployee}
      >
        <div className={'st_grid_active_box'}>
          <h5>{value}</h5>
        </div>
      </div>
    )
  }
}

export default SpaceTagGridActiveSlot;
